import { ToastAlertTypes } from '@genial/components';

export const reportGeneratorScreenName = 'report-generator';

export const defaultSuccessMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Solicitação realizada com sucesso',
  'Seu relatório está sendo gerado e aparecerá na lista em breve.',
];

export const defaultRetrySuccessMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Solicitação reenviada com sucesso',
  'Seu relatório está sendo gerado novamente e aparecerá na lista em breve.',
];

export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro ao enviar solicitação',
  'Não foi possível realizar esta solicitação, tente novamente mais tarde.',
];

export const defaultDownloadErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro ao fazer download do arquivo',
  'Não foi possível realizar o download do arquivo, tente novamente mais tarde.',
];
